import { fetchAuthSession } from 'aws-amplify/auth';
import { ROUTE_KEYS, ROUTES } from "../constants";
import { getLoginRedirect } from "../functions";
import { parseRoles } from "../../../util/login";
import { redirect } from "react-router-dom";
import { ROLES } from "../../../util/constants";

const rolesLoader = async ({ context, request }) => {
  const allowedRoles = context?.allowedRoles || Object.values(ROLES);
  const url = new URL(request?.url);
  const isLoginPage = url.pathname.startsWith(ROUTES[ROUTE_KEYS.LOGIN].path);  
  let isLoggedIn = false;
  let userRoles = [];
  
  try {
    const { tokens } = await fetchAuthSession();
    isLoggedIn = !!tokens?.idToken?.payload?.osuid;
    if (isLoggedIn) {
      userRoles = parseRoles(tokens);
    }
  } catch (error) {
    console.error('Error fetching auth session:', error);
  }
    const loginRedirect = getLoginRedirect({ url: request?.url }) || ROUTES[ROUTE_KEYS.LOGIN]?.path;
    if (!isLoginPage && !isLoggedIn) {
      return redirect(loginRedirect);
    }
  
  const isAuthorized = allowedRoles?.length
    ? allowedRoles.some((role) => userRoles?.length && userRoles.includes(role))
    : isLoggedIn; 

  const isUnauthPage = url.pathname.startsWith(ROUTES[ROUTE_KEYS.UNAUTH].path);
  const shouldRedirectToUnauth = !isAuthorized && !isUnauthPage;
  
  if (shouldRedirectToUnauth) {
    return redirect(ROUTES[ROUTE_KEYS.UNAUTH].path);
  }

  return {
    isLoggedIn,
    isAuthorized,
    allowedRoles,
  };
};

export default rolesLoader;
